<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8  ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2> Settlement Split</h2>
                </div>
                <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>  
                </div>
                <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
                (mouseout)="showpayment(false,'1')" id="1">
                <div
                    style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">
    
                    <iframe class="i-frame" src="https://www.youtube.com/embed/5kY7ApMM9Uo"
                        title="YouTube video player" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen></iframe>
                </div>    -->
                <div class="col-md-12" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')" id="2">
                    <label for="" class="mt-3">PayG Split Settlement is a feature designed to simplify the process of
                        paying your partners and suppliers effortlessly.</label>
                </div>


                <div class="col-md-12" (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')" id="3">
                    <h2 class="mt-5">Key Benefits of PayG Split Settlement:</h2>

                    <label for="" class="mt-3"><b>Effortless Transfers: &nbsp;</b> Stay focused on growing your business
                        while PayG takes care of settling amounts to your partners and suppliers seamlessly.</label>
                    <label for="" class="mt-3"><b>Time-Saving Solution: &nbsp;</b>Say goodbye to the manual hassle of
                        managing multiple transfers. PayG Split Settlement automates the process, saving you valuable
                        time.</label>
                    <label for="" class="mt-3"><b>Reduced Complexity: &nbsp;</b> Streamline your financial workflow by
                        consolidating settlement processes. Enjoy a clearer, more organized approach to managing
                        payouts.</label>
                    <label for="" class="mt-3"><b> Secure Transactions: &nbsp;</b>Rest easy knowing that PayG ensures
                        secure and reliable transfers, adhering to the highest industry standards for financial
                        transactions.</label>
                </div>

                <div class="col-md-12" (mouseover)="showpayment(true,'4')" (mouseout)="showpayment(false,'4')" id="4">
                    <h2 class="mt-5">How PayG Split Settlement Works:</h2>

                    <label for="" class="mt-3"><b> Automatic Calculation:&nbsp;</b>PayG intelligently calculates, and
                        splits settlement amounts based on your predefined parameters, ensuring accuracy and
                        efficiency.</label>
                    <label for="" class="mt-3"><b> Seamless Integration:&nbsp;</b>Integrate PayG Split Settlement
                        effortlessly into your existing systems. No need for complex setups or extensive technical
                        know-how.</label>
                    <label for="" class="mt-3"><b>Real-Time Tracking: &nbsp;</b>Gain real-time visibility into your
                        settlement processes. Track and monitor transactions conveniently through the PayG
                        dashboard.</label>
                    <label for="" class="mt-3"><b>Customizable Settings: &nbsp;</b>Tailor the settlement parameters
                        according to your specific business needs. PayG provides flexibility to accommodate various
                        partnership and supplier arrangements.</label>
                </div>
                <div class="col-md-12" (mouseover)="showpayment(true,'5')" (mouseout)="showpayment(false,'5')" id="5">
                    <h2 class="mt-5">

                        How to Activate PayG Split Settlement:

                    </h2>

                    <label for="" class="mt-3"><b>Account Activation: &nbsp;</b> Activate PayG Split Settlement through
                        a seamless process. Contact our support team to enable this feature for your account.</label>

                    <label for="" class="mt-3"><b>Select the Amount or Percentage: &nbsp;</b>Tailor your settlement
                        preferences by choosing to split amounts either by a fixed amount or a percentage. PayG empowers
                        you with flexibility.</label>

                    <label for="" class="mt-3"><b>Insert the Details: &nbsp;</b>Fill in the necessary details, including
                        recipient name, account number, purpose of payment, and more. This ensures transparent
                        communication with your partners or suppliers.</label>

                    <label for="" class="mt-3"><b>Get Notified: &nbsp;</b>Once the settlement is complete, PayG
                        automatically transfers the specified amounts to the provided account numbers. Simultaneously,
                        you receive instant notifications, keeping you informed about successful transactions.</label>

                    <label for="" class="mt-3"><b>Effortless Workflow: &nbsp;</b>Enjoy a streamlined financial workflow
                        as PayG simplifies the complexities of settling payments. Focus on growing your business while
                        we handle the hassle of transactions.</label>

                    <label for="" class="mt-3"><b>Customization Options: &nbsp;</b>Customize the settlement parameters
                        to align with your specific business needs. Whether you prefer a fixed amount or a
                        percentage-based split, PayG adapts to your preferences seamlessly.</label>

                    <label for="" class="mt-3"><b> Real-Time Tracking: &nbsp;</b> Monitor the entire process in
                        real-time through the PayG dashboard. Track settlements, view transaction details, and stay in
                        control of your financial operations.</label>

                    <label for="" class="mt-3"><b>Simplified Payments: &nbsp;</b> Say goodbye to manual efforts and
                        time-consuming payment processes. PayG Split Settlement transforms the way you handle payouts,
                        making it a hassle-free experience.</label>

                    <label for="" class="mt-3"><b>Enhanced Communication: &nbsp;</b> The details you input during the
                        process are shared with recipients, fostering transparency and efficient communication between
                        parties.

                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4 hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        Table of Contents:
                    </h5>

                </div>
                <div class="col-md-12 mt-2">
                    <!-- <a href="#1">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span class="videoHover" style="cursor: pointer;"
                                    [ngClass]="{'video':colors=='1'}" (click)="color('1')"
                                    >
                                    Introduction to
                                    Payment Gateways
                                </span>
                              
                            </div>
                        </div>
                    </a> -->
                </div>
                <div class="col-md-12 ">
                    <a href="#2">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')"> Settlement Split </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#3">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')"> Benefits of Settlement split </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#4">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')"> How it works? </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#5">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='5'}"
                                    (click)="color('5')">   How to activate it? </span>

                            </div>
                        </div>
                    </a>
                </div>      
            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8" style="width:70%">
                <a [routerLink]="['/price']"> <button class="btn btn-color" > <img
                            src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;Price
                    </button></a>

            </div>
            <div class="col-md-4        " style="width:30%">
                <a [routerLink]="['/report']"> <button class="btn btn-color"
                        (click)="menues('Reports')">Reports
                        &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>

            </div> 
        </div>
    </div>
</div>